import { call, put, takeEvery } from "redux-saga/effects";
import { showAlert } from "../../redux/slices/alerts";
import { safeErrorMessage } from "../../utils/errorUtils";
import * as duck from "./duck";
import * as requests from "./requests";

function* respond(callback, request, args, quiet) {
    try {
        const response = yield call(request, ...args);
        if (callback) callback(response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        if (!quiet && error?.response?.status !== 404) yield put(showAlert({ severity: "error", message }));
        if (callback) callback(null, message, error?.response?.status);
    }
}

const bind = (type, request, argsOf, quiet = false) =>
    takeEvery(type, function* (action) {
        const payload = action.payload || {};
        yield* respond(payload.callback, request, argsOf(payload), quiet);
    });

export default function* adaScansSaga() {
    yield bind(duck.ADA_GET_SITES_REQUEST, requests.requestGetSites, () => []);
    yield bind(duck.ADA_GET_SCANS_REQUEST, requests.requestGetScans, (p) => [p.siteUrl]);
    yield bind(duck.ADA_GET_SCAN_REQUEST, requests.requestGetScan, (p) => [p.scanId]);
    yield bind(duck.ADA_GET_FLEET_REQUEST, requests.requestGetFleet, () => []);
    yield bind(duck.ADA_GET_CLIENT_SCANS_REQUEST, requests.requestGetClientScans, (p) => [p.clientId, p.siteUrl]);
    yield bind(duck.ADA_GET_STAFF_SCAN_REQUEST, requests.requestGetStaffScan, (p) => [p.scanId]);
    yield bind(duck.ADA_GET_RULE_PAGES_REQUEST, requests.requestGetRulePages, (p) => [p.scanId, p.ruleId, p.page, p.limit, p.onlyNew]);
    yield bind(duck.ADA_IMPORT_SCAN_REQUEST, requests.requestImportScan, (p) => [p.file, p.clientId, p.scanDate], true);
    yield bind(duck.ADA_UPDATE_SCAN_DATE_REQUEST, requests.requestUpdateScanDate, (p) => [p.scanId, p.scanDate], true);
    yield bind(duck.ADA_ADD_SCAN_LINK_REQUEST, requests.requestAddScanLink, (p) => [p.scanId, p.kind, p.id]);
    yield bind(duck.ADA_REMOVE_SCAN_LINK_REQUEST, requests.requestRemoveScanLink, (p) => [p.scanId, p.kind, p.id]);
    yield bind(duck.ADA_DELETE_SCAN_REQUEST, requests.requestDeleteScan, (p) => [p.scanId], true);
    yield bind(duck.ADA_GET_LINK_TARGETS_REQUEST, requests.requestGetLinkTargets, (p) => [p.clientId, p.q]);
    yield bind(duck.ADA_SEARCH_CLIENTS_REQUEST, requests.requestSearchClients, (p) => [p.q]);
}
